import { Request } from '../../Servidor/Request';

export class DengueActivitiesRequest {
    private sgepatividadedengue: number;
    private nome: string;
    private codigo: string

    constructor(sgepatividadedengue: number, nome: string, codigo: string) {
        this.sgepatividadedengue = sgepatividadedengue;
        this.nome = nome;
        this.codigo = codigo;
    }


    /**
     * Getter sgepatividadedengue
     * @return {number}
     */
    public getSgepAtividadeDengue(): number {
        return this.sgepatividadedengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
    /**
    * Getter codigo
    * @return {string}
    */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class DengueActivitiesStructRequest {
    private sgepatividadedengue: number;

    constructor(sgepatividadedengue: number) {
        this.sgepatividadedengue = sgepatividadedengue;
    }


    /**
     * Getter sgepatividadedengue
     * @return {number}
     */
    public getSgepAtividadeDengue(): number {
        return this.sgepatividadedengue;
    }

}

export class DengueActivitiesStructResponse {
    private sgepatividadedengue: number;
    private nome: string;

    constructor(sgepatividadedengue: number, nome: string) {
        this.sgepatividadedengue = sgepatividadedengue;
        this.nome = nome;
    }


    /**
     * Getter sgepatividadedengue
     * @return {number}
     */
    public getSgepAtividadeDengue(): number {
        return this.sgepatividadedengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class DengueActivitiesInteractor {
    public fetchSave(request: DengueActivitiesRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/atividade/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: DengueActivitiesStructRequest): PromiseLike<DengueActivitiesStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/atividade/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}